<template>
  <div class="wd-footer">
    <div class="container">
      <div class="row wd-footer-detail-block">
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-4 p-10">
              <div class="float-left">
                <img src="/static/assets/images/Footer/support_number.png" height="48"/>
              </div>
              <div style="padding-left: 60px">
                <p>Support (Toll Free):</p>
                <a href="tel:8002619142">(800) 261-9142</a>
              </div>
            </div>
            <div class="col-md-4 p-10">
              <div class="float-left">
                <img src="/static/assets/images/Footer/email.png" width="48"/>
              </div>
              <div style="padding-left: 60px">
                <p>Email:</p>
                <a href="mailto:info@workmandashboard.com">info@workmandashboard.com</a>
              </div>
            </div>
            <div class="col-md-4 p-l-10">
              <div class="float-left">

                <img src="/static/assets/images/Footer/address.png" height="48"/>
              </div>
              <div style="padding-left: 60px">
                <p>Workman's Dashboard</p>
                <p>P.O. Box 1284</p>
                <p>North Bend. WA 98056</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 wd-footer-cpoyright-block">
          <a href="/">
            <img src="/static/assets/images/logo.png" height="32"/>
          </a>
          <div class="clearfix"></div>
          <p>2018 - Copyright © Workman’s Dashboard. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "vue-footer",
    data() {
      return {}
    }
  }
</script>